"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

export default function Footer() {
  const pathname = usePathname();
  if (pathname === "/editor" || pathname.startsWith("/share")) return null;
  return (
    <footer className="border-t border-edge bg-background">
      <div className="mx-auto max-w-6xl px-6 py-12">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link href="/" className="flex items-center gap-2 text-lg font-semibold">
              <svg width="24" height="24" viewBox="0 0 28 28" fill="none">
                <rect width="28" height="28" rx="6" fill="#7c5cfc" />
                <path
                  d="M8 20L18 8M18 8H12M18 8V14"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span>Pencil</span>
            </Link>
            <p className="mt-3 text-sm text-muted">
              Design on canvas. Land in code.
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 className="mb-3 text-sm font-semibold">Product</h4>
            <ul className="flex flex-col gap-2 text-sm text-muted">
              <li>
                <Link href="/downloads" className="hover:text-foreground">Downloads</Link>
              </li>
              <li>
                <Link href="/pricing" className="hover:text-foreground">Pricing</Link>
              </li>
              <li>
                <Link href="/docs" className="hover:text-foreground">Docs</Link>
              </li>
            </ul>
          </div>

          {/* Extensions */}
          <div>
            <h4 className="mb-3 text-sm font-semibold">Extensions</h4>
            <ul className="flex flex-col gap-2 text-sm text-muted">
              <li>
                <span className="hover:text-foreground">Cursor</span>
              </li>
              <li>
                <span className="hover:text-foreground">VS Code</span>
              </li>
              <li>
                <span className="hover:text-foreground">Open VSX</span>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="mb-3 text-sm font-semibold">Legal</h4>
            <ul className="flex flex-col gap-2 text-sm text-muted">
              <li>
                <Link href="/privacy" className="hover:text-foreground">Privacy Policy</Link>
              </li>
              <li>
                <Link href="/terms" className="hover:text-foreground">Terms of Use</Link>
              </li>
              <li>
                <Link href="/eula" className="hover:text-foreground">EULA</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-edge pt-6 text-center text-xs text-muted">
          &copy; {new Date().getFullYear()} Pencil. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
